import React from "react";
import styled from "styled-components";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
// Import required modules
import { EffectCoverflow, Navigation } from "swiper/modules";
import { FiArrowLeftCircle, FiArrowRightCircle } from "react-icons/fi";
import { IMG_BASE_URL } from "pages/selectCoach/selectCoach";

// Custom arrow components
const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <FiArrowLeftCircle
      onClick={onClick}
      color="rgb(160, 195, 221)"
      width={"50%"}
    />
  );
};

const NextArrow = (props) => {
  const { onClick } = props;
  return <FiArrowRightCircle onClick={onClick} color="#2ECF96" />;
};

const RezeptSlider = ({ data }) => {
  const [selectedItem, setSelectedItem] = React.useState(
    data?.length ? data[0] : {}
  );

  return (
    <SliderContainer>
      <SwiperWrapper>
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          loop={true}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: false,
          }}
          navigation={{
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          }}
          modules={[EffectCoverflow, Navigation]}
          initialSlide={3}
          onSlideChange={(swiper) => {
            // Get the real index accounting for loop mode
            const realIndex = swiper.realIndex;
            if (data[realIndex]) {
              setSelectedItem(data[realIndex]);
            }
          }}
        >
          {data.map((item, index) => {
            const imageUrl =
              "https://app.foodiary.app/" +
              item.imgpath +
              "/" +
              item.imgname +
              "." +
              item.imgtype;
            return (
              <SwiperSlide key={index}>
                <SlideItem>
                  <ImageCollage>
                    <CollageItem>
                      <img src={imageUrl} alt={item.imgname} />
                    </CollageItem>
                  </ImageCollage>
                </SlideItem>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <RecipeTitle>{selectedItem?.recipeName}</RecipeTitle>
        <RecipeCategory>{selectedItem?.mealName}</RecipeCategory>
        <CustomNavigation>
          <div className="swiper-button-prev custom">
            <PrevArrow />
          </div>
          <div className="swiper-button-next custom">
            <NextArrow />
          </div>
        </CustomNavigation>
      </SwiperWrapper>
    </SliderContainer>
  );
};

// Styled Components
const SliderContainer = styled.div`
  width: 100%;
  max-width: 973.5px;
  margin: 0 auto;
  padding-bottom: 60px; // Increased default bottom padding for navigation

  // Add media query for small devices
  @media (max-width: 380px) and (max-height: 800px) {
    padding-bottom: 80px; // Further increase for button space below navigation
  }
  //iphone 15 media query
  @media only screen and (width: 393px) and (height: 852px) {
    padding-bottom: 110px; // Further increase for button space below navigation
  }
`;

const SwiperWrapper = styled.div`
  position: relative;
  // Removed padding-bottom here, handled by SliderContainer
  padding-top: 0;
  overflow: hidden;

  .swiper {
    width: 100%;
    padding-top: 10px; // Reduced top padding
    padding-bottom: 10px; // Reduced bottom padding
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 280px;
    height: 380px; // Slightly reduced default height
    transition: all 0.3s ease;
    transform: scale(0.65);

    // Adjust slide size for small devices
    @media (max-width: 380px) and (max-height: 800px) {
      width: 200px; // Further reduced width
      height: 280px; // Further reduced height
      transform: scale(0.6);
    }
  }

  .swiper-slide-active {
    opacity: 1;
    transform: scale(1); // Changed active scale to 1 for less vertical growth
    z-index: 10;

    // Adjust active slide scale for small devices
    @media (max-width: 380px) and (max-height: 800px) {
      transform: scale(0.9); // Keep slightly smaller on very small screens
    }
  }

  /* 2nd slides (immediate adjacent to active) */
  .swiper-slide-prev,
  .swiper-slide-next {
    filter: blur(0);
    opacity: 0.9;
    transform: scale(0.8); // Adjusted scale
    z-index: 9;

    // Adjust adjacent slide scale for small devices
    @media (max-width: 380px) and (max-height: 800px) {
      transform: scale(0.7);
    }
  }

  /* 3rd slides (two slides away from active) */
  .swiper-slide-prev + .swiper-slide-prev,
  .swiper-slide-next + .swiper-slide-next {
    filter: blur(1px);
    opacity: 0.5;
    transform: scale(0.65); // Adjusted scale
    z-index: 8;

    // Adjust further slide scale for small devices
    @media (max-width: 380px) and (max-height: 800px) {
      transform: scale(0.55);
    }
  }
`;

const CustomNavigation = styled.div`
  // Removed relative positioning and height: 0
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px; // Space between arrows
  margin-top: 15px; // Space above arrows

  .swiper-button-prev.custom,
  .swiper-button-next.custom {
    position: static; // Changed from absolute
    width: 25px;
    height: 25px;
    background: none;
    margin: 0; // Reset margins

    &::after {
      display: none;
    }
  }

  // Removed left positioning rules
`;

const SlideItem = styled.div`
  padding: 10px;
  transition: all 0.3s ease;
  height: 100%;
`;

const ImageCollage = styled.div`
  border-radius: 24px;
  overflow: hidden;
  height: 100%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 8px solid white;
`;

const CollageItem = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const RecipeTitle = styled.div`
  text-align: center;
  margin: 10px 0 5px; // Adjusted top margin, removed negative margin
  color: #142c1f;
  font-family: "RubikMedium";
  font-size: 16px;

  // Adjust margin for small devices
  @media (max-width: 380px) and (max-height: 800px) {
    margin-top: 5px;
    font-size: 14px;
  }
`;

const RecipeCategory = styled.p`
  text-align: center;
  font-size: 16px;
  color: #44554c;
  margin: 0 0 10px 0; // Added bottom margin before navigation
`;

export default RezeptSlider;
